import * as i0 from '@angular/core';
import * as i1 from './calendar.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from 'ionic-angular/components/action-sheet/action-sheet-component';
import * as i5 from 'ionic-angular/components/alert/alert-component';
import * as i6 from 'ionic-angular/components/app/click-block';
import * as i7 from 'ionic-angular/components/app/app-root';
import * as i8 from 'ionic-angular/components/app/overlay-portal';
import * as i9 from 'ionic-angular/components/avatar/avatar';
import * as i10 from 'ionic-angular/components/backdrop/backdrop';
import * as i11 from 'ionic-angular/components/badge/badge';
import * as i12 from 'ionic-angular/components/button/button';
import * as i13 from 'ionic-angular/components/card/card';
import * as i14 from 'ionic-angular/components/card/card-content';
import * as i15 from 'ionic-angular/components/card/card-header';
import * as i16 from 'ionic-angular/components/card/card-title';
import * as i17 from 'ionic-angular/components/checkbox/checkbox';
import * as i18 from 'ionic-angular/components/chip/chip';
import * as i19 from 'ionic-angular/components/grid/col';
import * as i20 from 'ionic-angular/components/content/content';
import * as i21 from 'ionic-angular/components/datetime/datetime';
import * as i22 from 'ionic-angular/components/fab/fab';
import * as i23 from 'ionic-angular/components/fab/fab-container';
import * as i24 from 'ionic-angular/components/fab/fab-list';
import * as i25 from 'ionic-angular/components/grid/grid';
import * as i26 from 'ionic-angular/components/img/img';
import * as i27 from 'ionic-angular/components/icon/icon';
import * as i28 from 'ionic-angular/components/infinite-scroll/infinite-scroll';
import * as i29 from 'ionic-angular/components/infinite-scroll/infinite-scroll-content';
import * as i30 from 'ionic-angular/components/item/item';
import * as i31 from 'ionic-angular/components/item/item-content';
import * as i32 from 'ionic-angular/components/item/item-divider';
import * as i33 from 'ionic-angular/components/item/item-group';
import * as i34 from 'ionic-angular/components/item/item-options';
import * as i35 from 'ionic-angular/components/item/item-reorder';
import * as i36 from 'ionic-angular/components/item/item-sliding';
import * as i37 from 'ionic-angular/components/label/label';
import * as i38 from 'ionic-angular/components/list/list';
import * as i39 from 'ionic-angular/components/list/list-header';
import * as i40 from 'ionic-angular/components/item/reorder';
import * as i41 from 'ionic-angular/components/loading/loading-component';
import * as i42 from 'ionic-angular/components/menu/menu';
import * as i43 from 'ionic-angular/components/menu/menu-close';
import * as i44 from 'ionic-angular/components/menu/menu-toggle';
import * as i45 from 'ionic-angular/components/modal/modal-component';
import * as i46 from 'ionic-angular/components/nav/nav';
import * as i47 from 'ionic-angular/components/nav/nav-pop';
import * as i48 from 'ionic-angular/components/nav/nav-pop-anchor';
import * as i49 from 'ionic-angular/components/nav/nav-push';
import * as i50 from 'ionic-angular/components/nav/nav-push-anchor';
import * as i51 from 'ionic-angular/components/note/note';
import * as i52 from 'ionic-angular/components/option/option';
import * as i53 from 'ionic-angular/components/picker/picker-component';
import * as i54 from 'ionic-angular/components/picker/picker-column';
import * as i55 from 'ionic-angular/components/popover/popover-component';
import * as i56 from 'ionic-angular/components/radio/radio-button';
import * as i57 from 'ionic-angular/components/radio/radio-group';
import * as i58 from 'ionic-angular/components/range/range';
import * as i59 from 'ionic-angular/components/range/range-knob';
import * as i60 from 'ionic-angular/components/refresher/refresher';
import * as i61 from 'ionic-angular/components/refresher/refresher-content';
import * as i62 from 'ionic-angular/components/grid/row';
import * as i63 from 'ionic-angular/components/scroll/scroll';
import * as i64 from 'ionic-angular/components/searchbar/searchbar';
import * as i65 from 'ionic-angular/components/segment/segment';
import * as i66 from 'ionic-angular/components/segment/segment-button';
import * as i67 from 'ionic-angular/components/select/select';
import * as i68 from 'ionic-angular/components/select/select-popover-component';
import * as i69 from 'ionic-angular/components/show-hide-when/show-when';
import * as i70 from 'ionic-angular/components/show-hide-when/hide-when';
import * as i71 from 'ionic-angular/components/slides/slide';
import * as i72 from 'ionic-angular/components/slides/slides';
import * as i73 from 'ionic-angular/components/spinner/spinner';
import * as i74 from 'ionic-angular/components/split-pane/split-pane';
import * as i75 from 'ionic-angular/components/tabs/tab';
import * as i76 from 'ionic-angular/components/tabs/tab-button';
import * as i77 from 'ionic-angular/components/tabs/tab-highlight';
import * as i78 from 'ionic-angular/components/tabs/tabs';
import * as i79 from 'ionic-angular/components/input/input';
import * as i80 from 'ionic-angular/components/thumbnail/thumbnail';
import * as i81 from 'ionic-angular/components/toast/toast-component';
import * as i82 from 'ionic-angular/components/toggle/toggle';
import * as i83 from 'ionic-angular/components/toolbar/toolbar-footer';
import * as i84 from 'ionic-angular/components/toolbar/toolbar-header';
import * as i85 from 'ionic-angular/components/toolbar/toolbar';
import * as i86 from 'ionic-angular/components/toolbar/toolbar-item';
import * as i87 from 'ionic-angular/components/toolbar/toolbar-title';
import * as i88 from 'ionic-angular/components/toolbar/navbar';
import * as i89 from 'ionic-angular/components/typography/typography';
import * as i90 from 'ionic-angular/components/virtual-scroll/virtual-footer';
import * as i91 from 'ionic-angular/components/virtual-scroll/virtual-header';
import * as i92 from 'ionic-angular/components/virtual-scroll/virtual-item';
import * as i93 from 'ionic-angular/components/virtual-scroll/virtual-scroll';
import * as i94 from './monthview';
import * as i95 from './weekview';
import * as i96 from './dayview';
import * as i97 from './calendar';
import * as i98 from './init-position-scroll';
import * as i99 from 'ionic-angular/module';
export const NgCalendarModuleNgFactory:i0.NgModuleFactory<i1.NgCalendarModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵbf = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵq = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵbc = (<any>(null as any));
var _decl0_16:i3.ɵbe = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.FormControlDirective = (<any>(null as any));
var _decl0_33:i3.FormGroupDirective = (<any>(null as any));
var _decl0_34:i3.FormControlName = (<any>(null as any));
var _decl0_35:i3.FormGroupName = (<any>(null as any));
var _decl0_36:i3.FormArrayName = (<any>(null as any));
var _decl0_37:i4.ActionSheetCmp = (<any>(null as any));
var _decl0_38:i5.AlertCmp = (<any>(null as any));
var _decl0_39:i6.ClickBlock = (<any>(null as any));
var _decl0_40:i7.IonicApp = (<any>(null as any));
var _decl0_41:i8.OverlayPortal = (<any>(null as any));
var _decl0_42:i9.Avatar = (<any>(null as any));
var _decl0_43:i10.Backdrop = (<any>(null as any));
var _decl0_44:i11.Badge = (<any>(null as any));
var _decl0_45:i12.Button = (<any>(null as any));
var _decl0_46:i13.Card = (<any>(null as any));
var _decl0_47:i14.CardContent = (<any>(null as any));
var _decl0_48:i15.CardHeader = (<any>(null as any));
var _decl0_49:i16.CardTitle = (<any>(null as any));
var _decl0_50:i17.Checkbox = (<any>(null as any));
var _decl0_51:i18.Chip = (<any>(null as any));
var _decl0_52:i19.Col = (<any>(null as any));
var _decl0_53:i20.Content = (<any>(null as any));
var _decl0_54:i21.DateTime = (<any>(null as any));
var _decl0_55:i22.FabButton = (<any>(null as any));
var _decl0_56:i23.FabContainer = (<any>(null as any));
var _decl0_57:i24.FabList = (<any>(null as any));
var _decl0_58:i25.Grid = (<any>(null as any));
var _decl0_59:i26.Img = (<any>(null as any));
var _decl0_60:i27.Icon = (<any>(null as any));
var _decl0_61:i28.InfiniteScroll = (<any>(null as any));
var _decl0_62:i29.InfiniteScrollContent = (<any>(null as any));
var _decl0_63:i30.Item = (<any>(null as any));
var _decl0_64:i31.ItemContent = (<any>(null as any));
var _decl0_65:i32.ItemDivider = (<any>(null as any));
var _decl0_66:i33.ItemGroup = (<any>(null as any));
var _decl0_67:i34.ItemOptions = (<any>(null as any));
var _decl0_68:i35.ItemReorder = (<any>(null as any));
var _decl0_69:i36.ItemSliding = (<any>(null as any));
var _decl0_70:i37.Label = (<any>(null as any));
var _decl0_71:i38.List = (<any>(null as any));
var _decl0_72:i39.ListHeader = (<any>(null as any));
var _decl0_73:i40.Reorder = (<any>(null as any));
var _decl0_74:i41.LoadingCmp = (<any>(null as any));
var _decl0_75:i42.Menu = (<any>(null as any));
var _decl0_76:i43.MenuClose = (<any>(null as any));
var _decl0_77:i44.MenuToggle = (<any>(null as any));
var _decl0_78:i45.ModalCmp = (<any>(null as any));
var _decl0_79:i46.Nav = (<any>(null as any));
var _decl0_80:i47.NavPop = (<any>(null as any));
var _decl0_81:i48.NavPopAnchor = (<any>(null as any));
var _decl0_82:i49.NavPush = (<any>(null as any));
var _decl0_83:i50.NavPushAnchor = (<any>(null as any));
var _decl0_84:i51.Note = (<any>(null as any));
var _decl0_85:i52.Option = (<any>(null as any));
var _decl0_86:i53.PickerCmp = (<any>(null as any));
var _decl0_87:i54.PickerColumnCmp = (<any>(null as any));
var _decl0_88:i55.PopoverCmp = (<any>(null as any));
var _decl0_89:i56.RadioButton = (<any>(null as any));
var _decl0_90:i57.RadioGroup = (<any>(null as any));
var _decl0_91:i58.Range = (<any>(null as any));
var _decl0_92:i59.RangeKnob = (<any>(null as any));
var _decl0_93:i60.Refresher = (<any>(null as any));
var _decl0_94:i61.RefresherContent = (<any>(null as any));
var _decl0_95:i62.Row = (<any>(null as any));
var _decl0_96:i63.Scroll = (<any>(null as any));
var _decl0_97:i64.Searchbar = (<any>(null as any));
var _decl0_98:i65.Segment = (<any>(null as any));
var _decl0_99:i66.SegmentButton = (<any>(null as any));
var _decl0_100:i67.Select = (<any>(null as any));
var _decl0_101:i68.SelectPopover = (<any>(null as any));
var _decl0_102:i69.ShowWhen = (<any>(null as any));
var _decl0_103:i70.HideWhen = (<any>(null as any));
var _decl0_104:i71.Slide = (<any>(null as any));
var _decl0_105:i72.Slides = (<any>(null as any));
var _decl0_106:i73.Spinner = (<any>(null as any));
var _decl0_107:i74.SplitPane = (<any>(null as any));
var _decl0_108:i75.Tab = (<any>(null as any));
var _decl0_109:i76.TabButton = (<any>(null as any));
var _decl0_110:i77.TabHighlight = (<any>(null as any));
var _decl0_111:i78.Tabs = (<any>(null as any));
var _decl0_112:i79.TextInput = (<any>(null as any));
var _decl0_113:i80.Thumbnail = (<any>(null as any));
var _decl0_114:i81.ToastCmp = (<any>(null as any));
var _decl0_115:i82.Toggle = (<any>(null as any));
var _decl0_116:i83.Footer = (<any>(null as any));
var _decl0_117:i84.Header = (<any>(null as any));
var _decl0_118:i85.Toolbar = (<any>(null as any));
var _decl0_119:i86.ToolbarItem = (<any>(null as any));
var _decl0_120:i87.ToolbarTitle = (<any>(null as any));
var _decl0_121:i88.Navbar = (<any>(null as any));
var _decl0_122:i89.Typography = (<any>(null as any));
var _decl0_123:i90.VirtualFooter = (<any>(null as any));
var _decl0_124:i91.VirtualHeader = (<any>(null as any));
var _decl0_125:i92.VirtualItem = (<any>(null as any));
var _decl0_126:i93.VirtualScroll = (<any>(null as any));
var _decl0_127:i94.MonthViewComponent = (<any>(null as any));
var _decl0_128:i95.WeekViewComponent = (<any>(null as any));
var _decl0_129:i96.DayViewComponent = (<any>(null as any));
var _decl0_130:i97.CalendarComponent = (<any>(null as any));
var _decl0_131:i98.initPositionScrollComponent = (<any>(null as any));
var _decl0_132:i2.AsyncPipe = (<any>(null as any));
var _decl0_133:i2.UpperCasePipe = (<any>(null as any));
var _decl0_134:i2.LowerCasePipe = (<any>(null as any));
var _decl0_135:i2.JsonPipe = (<any>(null as any));
var _decl0_136:i2.SlicePipe = (<any>(null as any));
var _decl0_137:i2.DecimalPipe = (<any>(null as any));
var _decl0_138:i2.PercentPipe = (<any>(null as any));
var _decl0_139:i2.TitleCasePipe = (<any>(null as any));
var _decl0_140:i2.CurrencyPipe = (<any>(null as any));
var _decl0_141:i2.DatePipe = (<any>(null as any));
var _decl0_142:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_143:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_144:i99.IonicModule = (<any>(null as any));
function _View_MonthViewComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_MonthViewComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
  const currVal_1:any = _decl0_127.dir;
  currVal_1;
  const currVal_2:any = _decl0_127.spaceBetween;
  currVal_2;
  const currVal_3:any = (0 === _decl0_127.currentViewIndex);
  currVal_3;
  const currVal_4:any = (0 !== _decl0_127.currentViewIndex);
  currVal_4;
  const currVal_5:any = (1 === _decl0_127.currentViewIndex);
  currVal_5;
  const currVal_6:any = (1 !== _decl0_127.currentViewIndex);
  currVal_6;
  const currVal_7:any = (2 === _decl0_127.currentViewIndex);
  currVal_7;
  const currVal_8:any = (2 !== _decl0_127.currentViewIndex);
  currVal_8;
  const currVal_9:any = (<any>{showEventDetail:_decl0_127.showEventDetail,selectedDate:_decl0_127.selectedDate,
      noEventsLabel:_decl0_127.noEventsLabel});
  currVal_9;
  const currVal_10:any = _decl0_127.monthviewEventDetailTemplate;
  currVal_10;
  const pd_11:any = ((<any>_decl0_127.onSlideChanged()) !== false);
}
function _View_WeekViewComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_WeekViewComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
  const currVal_1:any = _decl0_128.dir;
  currVal_1;
  const currVal_2:any = _decl0_128.spaceBetween;
  currVal_2;
  const currVal_3:any = _decl0_128.views[0].dates;
  currVal_3;
  const currVal_4:any = (0 === _decl0_128.currentViewIndex);
  currVal_4;
  const currVal_5:any = (0 !== _decl0_128.currentViewIndex);
  currVal_5;
  const currVal_6:any = _decl0_128.views[1].dates;
  currVal_6;
  const currVal_7:any = (1 === _decl0_128.currentViewIndex);
  currVal_7;
  const currVal_8:any = (1 !== _decl0_128.currentViewIndex);
  currVal_8;
  const currVal_9:any = _decl0_128.views[2].dates;
  currVal_9;
  const currVal_10:any = (2 === _decl0_128.currentViewIndex);
  currVal_10;
  const currVal_11:any = (2 !== _decl0_128.currentViewIndex);
  currVal_11;
  const pd_12:any = ((<any>_decl0_128.onSlideChanged()) !== false);
}
function _View_DayViewComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_DayViewComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
  const currVal_1:any = _decl0_129.dir;
  currVal_1;
  const currVal_2:any = _decl0_129.spaceBetween;
  currVal_2;
  const currVal_3:any = _decl0_129.allDayLabel;
  currVal_3;
  const currVal_4:any = 'true';
  currVal_4;
  const currVal_5:any = 'false';
  currVal_5;
  const currVal_6:any = (0 === _decl0_129.currentViewIndex);
  currVal_6;
  const currVal_7:any = (0 !== _decl0_129.currentViewIndex);
  currVal_7;
  const currVal_8:any = (0 === _decl0_129.currentViewIndex);
  currVal_8;
  const currVal_9:any = (0 !== _decl0_129.currentViewIndex);
  currVal_9;
  const currVal_10:any = _decl0_129.allDayLabel;
  currVal_10;
  const currVal_11:any = 'true';
  currVal_11;
  const currVal_12:any = 'false';
  currVal_12;
  const currVal_13:any = (1 === _decl0_129.currentViewIndex);
  currVal_13;
  const currVal_14:any = (1 !== _decl0_129.currentViewIndex);
  currVal_14;
  const currVal_15:any = (1 === _decl0_129.currentViewIndex);
  currVal_15;
  const currVal_16:any = (1 !== _decl0_129.currentViewIndex);
  currVal_16;
  const currVal_17:any = _decl0_129.allDayLabel;
  currVal_17;
  const currVal_18:any = 'true';
  currVal_18;
  const currVal_19:any = 'false';
  currVal_19;
  const currVal_20:any = (2 === _decl0_129.currentViewIndex);
  currVal_20;
  const currVal_21:any = (2 !== _decl0_129.currentViewIndex);
  currVal_21;
  const currVal_22:any = (2 === _decl0_129.currentViewIndex);
  currVal_22;
  const currVal_23:any = (2 !== _decl0_129.currentViewIndex);
  currVal_23;
  const pd_24:any = ((<any>_decl0_129.onSlideChanged()) !== false);
}
function _View_CalendarComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_CalendarComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_130.calendarMode;
  currVal_0;
  const currVal_1:any = i0.ɵinlineInterpolate(1,'',_decl0_130.calendarMode,'view-container');
  currVal_1;
  const currVal_2:any = 'month';
  currVal_2;
  const currVal_3:any = 'week';
  currVal_3;
  const currVal_4:any = 'day';
  currVal_4;
}
function _View_initPositionScrollComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_initPositionScrollComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'true';
  currVal_0;
  const currVal_1:any = 'false';
  currVal_1;
}
